/**
 * Transaction GraphQL Mutations (7 total)
 *
 * Complete mutation coverage for Transaction primitive:
 * 1. createSagaTransaction - Create saga transaction (Formula #7)
 * 2. updateTransactionStatus - Update transaction status
 * 3. abortTransaction - Emergency abort (life-critical)
 * 4. commitTransaction - Commit transaction
 * 5. rollbackTransaction - Rollback transaction
 * 6. deleteTransaction - Delete transaction
 * 7. addCheckpointToTransaction - Link checkpoint to transaction
 */

import { gql } from '@apollo/client';
import { TRANSACTION_FIELDS } from './fragments';

/**
 * Create saga transaction (Formula #7)
 */
export const CREATE_SAGA_TRANSACTION = gql`
  ${TRANSACTION_FIELDS}
  mutation CreateSagaTransaction($input: CreateSagaTransactionInput!) {
    createSagaTransaction(input: $input) {
      ...TransactionFields
    }
  }
`;

/**
 * Update transaction status
 */
export const UPDATE_TRANSACTION_STATUS = gql`
  ${TRANSACTION_FIELDS}
  mutation UpdateTransactionStatus($input: UpdateTransactionStatusInput!) {
    updateTransactionStatus(input: $input) {
      ...TransactionFields
    }
  }
`;

/**
 * Abort transaction (emergency abort for life-critical scenarios)
 */
export const ABORT_TRANSACTION = gql`
  ${TRANSACTION_FIELDS}
  mutation AbortTransaction($input: AbortTransactionInput!) {
    abortTransaction(input: $input) {
      ...TransactionFields
    }
  }
`;

/**
 * Commit transaction
 */
export const COMMIT_TRANSACTION = gql`
  ${TRANSACTION_FIELDS}
  mutation CommitTransaction($tenantId: String!, $transactionId: String!) {
    commitTransaction(tenantId: $tenantId, transactionId: $transactionId) {
      ...TransactionFields
    }
  }
`;

/**
 * Rollback transaction
 */
export const ROLLBACK_TRANSACTION = gql`
  ${TRANSACTION_FIELDS}
  mutation RollbackTransaction($tenantId: String!, $transactionId: String!) {
    rollbackTransaction(tenantId: $tenantId, transactionId: $transactionId) {
      ...TransactionFields
    }
  }
`;

/**
 * Delete transaction
 */
export const DELETE_TRANSACTION = gql`
  mutation DeleteTransaction($tenantId: String!, $transactionId: String!) {
    deleteTransaction(tenantId: $tenantId, transactionId: $transactionId)
  }
`;

/**
 * Add checkpoint to transaction
 */
export const ADD_CHECKPOINT_TO_TRANSACTION = gql`
  ${TRANSACTION_FIELDS}
  mutation AddCheckpointToTransaction(
    $tenantId: String!
    $transactionId: String!
    $checkpointId: String!
  ) {
    addCheckpointToTransaction(
      tenantId: $tenantId
      transactionId: $transactionId
      checkpointId: $checkpointId
    ) {
      ...TransactionFields
    }
  }
`;
